<template>
  <div id="cta" class="container">
    <div class="cta-wrap style1 ptb-100 bg-f">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="content-title style2">
            <span>Call To Action</span>
            <h2>Are You Ready To Receive Your Physical Therapy Services?</h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              standard dummy text ever since the 1500s, printer type.
            </p>
          </div>
        </div>

        <div class="col-lg-6">
          <form action="#" class="cta-form">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" placeholder="Your Name" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" placeholder="Your Email" />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <textarea
                    name="message"
                    id="message"
                    cols="30"
                    rows="10"
                    placeholder="Your Question"
                  ></textarea>
                </div>
              </div>
              <div class="col-12">
                <button class="btn style2">Start Chat</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallToAction",
};
</script>